import Modulo from './class.modulo';
import Base from './class.base';
import Piede from './class.piede';
import { sceneManager } from "./class.scenemanager";
import { ui } from "./class.ui";
import { palette } from "./class.palette";
import Top from "./class.top";
import {textures} from './textures';

/**
 * TIPI DI MODULI
 *
 * 0 - Modulo da 60
 * 1 - Modulo da 120
 * 2 - Modulo da 60 vuoto
 * 3 - Modulo da 60 con cassetti
 *
 */


//TODO la scena non deve pià essere passata ad ogni costruttore
// nb fai un commit prima che è meglio
class GestoreModuli {
    constructor() {
        this.genera('1201');
        this._showWireframe = sceneManager._showWireframe;
        // this._mobileParent.scaling = new BABYLON.Vector3(0.1, 0.1, 0.1);
        // this._mobileParent.position = new BABYLON.Vector3(0, 12, 0);
        /*this._mobileParent.scaling = new BABYLON.Vector3(10, 10, 10);*/
    }

    genera(modello) {
        this._mobileParent = new BABYLON.Mesh('mobileParent', sceneManager._scene);
        const manager = new BABYLON.AssetsManager(sceneManager._scene);
        switch (modello) {
            case '1201':
                this._codice = '1201';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,1]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, -60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1202':
                this._codice = '1202';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 1, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1203':
                this._codice = '1203';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1204':
                this._codice = '1204';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 1, [0, 0, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 0, 0], this._mobileParent, 2, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1205':
                this._codice = '1205';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1206':
                this._codice = '1206';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1207':
                this._codice = '1207';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 4, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 5, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 6, [1,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1208':
                this._codice = '1208';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 3, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 4),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 5, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 6, [1,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1209':
                this._codice = '1209';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 6, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 6, [0, -60, 0], this._mobileParent, 2, [0,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1210':
                this._codice = '1210';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 1, [1,1]),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1211':
                this._codice = '1211';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 3, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1212':
                this._codice = '1212';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1213':
                this._codice = '1213';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1214':
                this._codice = '1214';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 5, [60, 60, 0], this._mobileParent, 2, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1215':
                this._codice = '1215';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 60, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 3, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1216':
                this._codice = '1216';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 60, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 3, [60, 0, 0], this._mobileParent, 3, [1,1]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1217':
                this._codice = '1217';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 3, [0, 0, 0], this._mobileParent, 3, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 4),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 5, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 6, [1,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1218':
                this._codice = '1218';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 3, [60, 0, 0], this._mobileParent, 4, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 5, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 6, [1,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1219':
                this._codice = '1219';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 3, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 4),
                    new Modulo(sceneManager._scene, manager, 6, [0, -60, 0], this._mobileParent, 5, [0,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1220':
                this._codice = '1220';
                this._dimensione = '120';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 4, [1,1]),
                    new Modulo(sceneManager._scene, manager, 6, [0, -60, 0], this._mobileParent, 5, [0,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1221':
                this._codice = '1221';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1222':
                // TODO controllare numerazione
                this._codice = '1222';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 5, [60, 60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1223':
                this._codice = '1223';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 60, 0], this._mobileParent, 2, [1,2]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1224':
                this._codice = '1224';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 5, [60, 60, 0], this._mobileParent, 4, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '120', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet120(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '120', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1801':
                this._codice = '1801';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, -60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1802':
                this._codice = '1802';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 1, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 4, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1803':
                this._codice = '1803';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 4, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1804':
                this._codice = '1804';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 2, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1805':
                this._codice = '1805';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1806':
                this._codice = '1806';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 1, [0, 0, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 0, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 1, [120, 0, 0], this._mobileParent, 3, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1807':
                this._codice = '1807';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 3, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1808':
                this._codice = '1808';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 2, [120, 0, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1809':
                this._codice = '1809';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [120, 60, 0], this._mobileParent, 1, [2,2]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 3, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1810':
                this._codice = '1810';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 2, [0,1]),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 3, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1811':
                this._codice = '1811';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 6, [60, -60, 0], this._mobileParent, 2, [1,0]),

                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, -60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-60, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1812':
                this._codice = '1812';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 1, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 2, [2,1]),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1813':
                this._codice = '1813';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 3, [120, 0, 0], this._mobileParent, 1, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 3, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 4, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1814':
                this._codice = '1814';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 3, [120, 0, 0], this._mobileParent, 1, [2,1]),
                    new Modulo(sceneManager._scene, manager, 6, [0, -60, 0], this._mobileParent, 2, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1815':
                this._codice = '1815';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 3, [2,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 6, [60, -60, 0], this._mobileParent, 5, [1,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1816':
                this._codice = '1816';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [120, 0, 0], this._mobileParent, 3, [2,1]),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 0, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '1817':
                this._codice = '1817';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 60, 0], this._mobileParent, 1, [0,2]),
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 2, [0,1]),
                    new Modulo(sceneManager._scene, manager, 3, [60, 0, 0], this._mobileParent, 3, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 4, [0,0]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 5, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 6, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1818':
                this._codice = '1818';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 0, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1819':
                this._codice = '1819';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 60, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 1, [120, 60, 0], this._mobileParent, 3, [2,1]),
                    new Modulo(sceneManager._scene, manager, 3, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 3, [120, -60, 0], this._mobileParent, 5, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;
            case '1820':
                this._codice = '1820';
                this._dimensione = '180';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 5, [0, 60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 5, [60, 60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 5, [120, 60, 0], this._mobileParent, 3, [2,0]),
                ];
                // gestisco la base
                this._base = new Base(sceneManager._scene, manager, '180', [0, -120, 0], this._mobileParent);

                this._piedi = this.createFeet180(sceneManager._scene, manager, this._mobileParent);

                this._top = new Top(sceneManager._scene, manager, '180', [0, 60, 0], this._mobileParent);

                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-90, (60 + 13), 22.5);
                this._modelWidth = 180;

                manager.load();

                break;

            case '2401':
                this._codice = '2401';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2402':
                this._codice = '2402';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 2, [60, -60, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;
            case '2403':
                this._codice = '2403';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 2, [120, -60, 0], this._mobileParent, 3),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;
            case '2404':
                this._codice = '2404';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [120, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [180, 0, 0], this._mobileParent, 2, [3,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 6, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;
            case '2405':
                this._codice = '2405';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 6, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2406':
                this._codice = '2406';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 1, [0, 0, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 1, [60, 0, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 1, [120, 0, 0], this._mobileParent, 3, [2,0]),
                    new Modulo(sceneManager._scene, manager, 1, [180, 0, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, 0, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2407':
                this._codice = '2407';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 6, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 3, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;


            case '2408':
                this._codice = '2408';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                    new Modulo(sceneManager._scene, manager, 3, [180, -60, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2409':
                this._codice = '2409';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, -60, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 2, [1,0]),
                    new Modulo(sceneManager._scene, manager, 6, [120, -60, 0], this._mobileParent, 3, [2,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;


            case '2410':
                this._codice = '2410';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 1, [0,0]),
                    new Modulo(sceneManager._scene, manager, 2, [60, -60, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 3, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 4, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                this._top = new Top(sceneManager._scene, manager, '240', [0, -60, 0], this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2411':
                this._codice = '2411';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 3, [0, 0, 0], this._mobileParent, 1, [0,1]),
                    new Modulo(sceneManager._scene, manager, 2, [60, 0, 0], this._mobileParent, 2),
                    new Modulo(sceneManager._scene, manager, 3, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 0, [120, -60, 0], this._mobileParent, 5, [2,0]),
                    new Modulo(sceneManager._scene, manager, 0, [180, -60, 0], this._mobileParent, 6, [3,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

            case '2412':
                this._codice = '2412';
                this._dimensione = '240';
                this._moduli = [
                    new Modulo(sceneManager._scene, manager, 2, [0, 0, 0], this._mobileParent, 1),
                    new Modulo(sceneManager._scene, manager, 0, [60, 0, 0], this._mobileParent, 2, [1,1]),
                    new Modulo(sceneManager._scene, manager, 0, [0, -60, 0], this._mobileParent, 3, [0,0]),
                    new Modulo(sceneManager._scene, manager, 0, [60, -60, 0], this._mobileParent, 4, [1,0]),
                    new Modulo(sceneManager._scene, manager, 6, [120, -60, 0], this._mobileParent, 5, [2,0]),
                ];

                this._base = new Base(sceneManager._scene, manager, '240', [0, -120, 0], this._mobileParent);
                this._piedi = this.createFeet240(sceneManager._scene, manager, this._mobileParent);
                // posizioni il mobile
                this._mobileParent.position = new BABYLON.Vector3(-120, (60 + 13), 22.5);

                this._modelWidth = 240;

                manager.load();
                break;

        }
        // this._mobileParent.scaling = new BABYLON.Vector3(.1, .1, .1);
        // this._mobileParent.position = new BABYLON.Vector3(0, 0, 0);
    }

    updateBodyTexture(textureUrl)
    {
        const textureManager = new BABYLON.AssetsManager(sceneManager._scene);
        const task = textureManager.addTextureTask('texture', textureUrl);

        task.onSuccess = () => {
            this._moduli.forEach( modulo => {
                if (modulo._type !== 2) {
                    modulo._anta.setTexture(textureUrl);
                }
            });
        };

        textureManager.load();
    }

    updateBodyToCurrentColor() {
        let color = ui._selectedColor;
        for (let i = 0; i < this._moduli.length; i++) {
            this._moduli[i]._cassa.setColor(color)
        }
        if (this._top !== null) {
            this._top.setColor(color);
        }
    }

    highlightBody(status) {
        let color = ui._selectedColor;
        this._moduli.map(modulo => {
            modulo.highlightCassa(status, color);
        });
        if (this._top !== null) {
            this._top.highlightTop(status, color);
        }
    }

    changeFoot(type, index) {
        this._piedi[index].switchMesh(type);
    }

    changeBase(type) {
        this._piedi.map(piede => {
            piede.feetState(type)
        });
        this._base.switchMesh(type);
    }

    selectFoot(index) {
        this._selectedFoot = index;
        this._piedi[index].selectFoot(true);
    }

    deselectFoot() {
        this._piedi[this._selectedFoot].selectFoot(false);
    }

    createFeet120(scene, assetManager, parent) {
        return [
            new Piede(scene, assetManager, 0, [7.5, -123, -37.5], parent, 1),
            new Piede(scene, assetManager, 0, [112.5, -123, -37.5], parent, 2),
            new Piede(scene, assetManager, 0, [7.5, -123, -7.5], parent, 4),
            new Piede(scene, assetManager, 0, [112.5, -123, -7.5], parent, 5)
        ]
    }

    createFeet180(scene, assetManager, parent) {
        return [
            new Piede(scene, assetManager, 0, [7.5, -123, -37.5], parent, 1),
            new Piede(scene, assetManager, 0, [90, -123, -37.5], parent, 2),
            new Piede(scene, assetManager, 0, [172.5, -123, -37.5], parent, 3),
            new Piede(scene, assetManager, 0, [7.5, -123, -7.5], parent, 4),
            new Piede(scene, assetManager, 0, [90, -123, -7.5], parent, 5),
            new Piede(scene, assetManager, 0, [172.5, -123, -7.5], parent, 6)
        ]
    }
    createFeet240(scene, assetManager, parent) {
        return [
            new Piede(scene, assetManager, 0, [7.5, -123, -37.5], parent, 1),
            new Piede(scene, assetManager, 0, [82.25, -123, -37.5], parent, 2),
            new Piede(scene, assetManager, 0, [157.75, -123, -37.5], parent, 3),
            new Piede(scene, assetManager, 0, [232.5, -123, -37.5], parent, 4),
            new Piede(scene, assetManager, 0, [7.5, -123, -7.5], parent, 5),
            new Piede(scene, assetManager, 0, [120, -123, -7.5], parent, 6),
            new Piede(scene, assetManager, 0, [232.5, -123, -7.5], parent, 7)
        ]
    }

    changeMobile(type) {
        this._moduli.map(modulo => {
            modulo.destroy();
        });
        this._piedi.map(piede => {
            piede.destroy();
        });
        this._base.destroy();
        if ( this._top ) {
            this._top.destroy();
        }
        this._mobileParent.dispose();
        this._showWireframe = true;

        this.genera(type.toString());

        ui.reloadUi(type);
    }

    toggleOutline() {
        this._showWireframe = sceneManager._showWireframe = !sceneManager._showWireframe;
        document.getElementById('toggleOutline').innerHTML = sceneManager._showWireframe ? 'Nascondi Griglia / Hide Grid' : 'Mostra Griglia / Show Grid';
        for (let i = 0; i < this._moduli.length; i++) {
            this._moduli[i].toggleOutline(sceneManager._showWireframe);
        }
    }

    toggleTop() {
        this._top.toggleVisibility();
    }

    toggleFeet() {
        this._piedi.map(p => {
            p.toggleVisibility()
        })
    }

    showFeet() {
        this._piedi.map(p => {
            p.showFeet()
        })
    }

    test() {
        this._base.destroy();
        /*let assetManager = new BABYLON.AssetsManager(sceneManager._scene);
        let base = new Base(sceneManager._scene, assetManager, 'A', '180', [0,250,0], this._mobileParent);
        assetManager.load();*/
    }

    extractData() {
        let json = {};
        json.codice = this._codice;
        json.appMode = sceneManager.appModeTitle;
        json.coloreBase = palette.rgbToName(this._base._currentColor);
        json.coloreCasse = palette.rgbToName(this._moduli[0]._cassa._currentColor);
        json.dimensione = this._dimensione;
        json.top = sceneManager._topVisible;


        // base
        const baseJson = this._base.extractData();

        // PIEDI
        let piediJson = [];
        for (let i = 0; i < this._piedi.length; i++) {
            piediJson.push(this._piedi[i].extractData());
        }
        // MODULI
        let moduliJson = [];
        for (let i = 0; i < this._moduli.length; i++) {
            moduliJson.push(this._moduli[i].extractData());
        }

        json.listaModuli = moduliJson;
        json.listaPiedi = piediJson;
        json.base = baseJson;

        json.screenshot = sceneManager.takeScreenshot(sceneManager._engine, sceneManager._screenshotCamera);

        return json;
    }

}

export const gestoreModuli = new GestoreModuli();
export default gestoreModuli;
